class VoteStatsComponent extends React.PureComponent {
	constructor(props){
		super(props);
		this.state = {
			voteCount : '',
			animate: false
		}
		this.countElement = null;
		this.removeAnimation = this.removeAnimation.bind(this);
	}
	removeAnimation(){
		this.setState({animate: false});
	}
		
	componentDidMount(){
		this.countElement.addEventListener('animationend', this.removeAnimation);
		window.firebase.database().ref('/votes/' + this.props.vote).on('value', (snapshot) => {
			let voteCount = snapshot.val();
			this.setState({
				voteCount: voteCount,
				animate: true
			});
		});
	}
	render() {
		return (
			<div ref={el => {this.countElement = el}} className={"vote__counter " + (this.state.animate ? 'animate' : '')}>
				<div className="vote__count__number">{this.state.voteCount}</div>
				<div className="vote__count__heart">
					<i className="fa icon-heart" aria-hidden="true" />
				</div>
			</div>
		);
	}
}
export { VoteStatsComponent };



// WEBPACK FOOTER //
// in/js/custom-components/specials/vote-stats-component.js